import { ToastService } from './../../../../../core/toast.service';
import { AbstractControl } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-read-csv',
  templateUrl: './read-csv.component.html',
  styleUrls: ['./read-csv.component.scss']
})
export class ReadCsvComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */
  //array varibales to store csv data
  lines = []; //for headings
  linesR = []; // for rows
  @Input()
  fileInput: AbstractControl;

  @Output()
  content = new EventEmitter<any>();
/* ------------------------------- constructor ------------------------------ */

  constructor() { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

  addFile(ev: any){
      this.fileInput.setValue(ev);
  }

  removeUrl(){
    this.fileInput.setValue(null);
  }

   //File upload function
   setFiles(files: FileList){
     if(files && files.length > 0) {
        let file : File = files.item(0);
          //File reader method
          let reader: FileReader = new FileReader();
          reader.readAsText(file);
          reader.onload = (e) => {
           let csv: any = reader.result;
           let allTextLines = [];
           allTextLines = csv.split(/\r\n/);
          //Table Headings
           let headers = allTextLines[0].split(',');
           let data = headers;
           let tarr = [];
           for (let j = 0; j < headers.length; j++) {
             tarr.push(data[j]);
           }
           //Pushed headings to array variable
           this.lines.push(tarr);
           // Table Rows
           let tarrR = [];
           let arrl = allTextLines.length;
           let rows = [];
           for(let i = 1; i < arrl; i++){
            rows.push(allTextLines[i].split(','));
           }
           console.log(rows);
           for (let j = 0; j < (arrl-1); j++) {
            tarrR.push(rows[j]);
           }
          //Push rows to array variable
           this.linesR.push(tarrR);
           this.content.emit(tarrR);
       }
     }
   }

}


